"use client";

import Header from "./Header";

export default function HeaderWrapper() {
  return <Header />;
}
